import tagular from '../store/helpers/tagular'
import { v4 as uuid } from 'uuid'

const {
  formStarted,
  elementClicked,
  formContinued,
  formSubmitted,
  productListViewed,
  productViewed
} = tagular

const tagularEventHandlersMap = {
  FormStarted,
  ElementClicked,
  FormContinued,
  FormSubmitted,
  ProductListViewed,
  ProductViewed
}

function FormStarted({ formType, formName, formId }) {
  formStarted(formType, formName, formId)
}

function ElementClicked({ webElement, actionOutcome, formId, outboundUrl }) {
  elementClicked(webElement, actionOutcome, outboundUrl, formId)
}

function FormContinued({ formType, formName, formId }) {
  formContinued(formType, formName, formId)
}

function FormSubmitted({ formName, formFields, formType, formId }) {
  formSubmitted(formId, formName, formFields, formType)
}

function ProductListViewed({ productList }) {
  productListViewed(uuid(), 'deposits', productList, null)
}

function ProductViewed({ productId, brand, position, location, formId }) {
  productViewed(productId, brand, position, formId, 'deposits', location)
}

export function sendRecoWidgetTagularEvent(value) {
  const { tagularEventType, payload } = value
  const tagularEventHandler = tagularEventHandlersMap[tagularEventType]

  if (tagularEventHandler) {
    tagularEventHandler(payload)
  }
}
